import { useEffect, useState } from 'react'
import { createStrictContext } from 'utils/createContext'
import { usePayItemSelectContext } from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { simpleErrorNotification } from 'hooks/notificationHandler'
import { SummaryContext, SummarySelection } from './types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<SummaryContext>('SummaryContext')

export const useSummaryContext = useContextFn

const SummaryProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const [globalId, setGlobalId] = useState<string | undefined>()
  const [selected, setSelected] = useState<SummarySelection | undefined>()
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setGlobalId(undefined)
    setSelected(undefined)
  }, [projectId])

  const { payItems } = usePayItemSelectContext()
  const [copied, setCopied] = useState<string | undefined>()
  useEffect(() => {
    if (!globalId || !payItems) return
    const found = payItems.find((payItem) => payItem.globalId === globalId)
    if (!found)
      return simpleErrorNotification(
        `Could not find a Pay Item by ${globalId}. Try selecting a different Pay Item`
      )
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setCopied(found.label)
  }, [globalId, payItems])
  return (
    <Provider
      value={{
        copied,
        globalId,
        setGlobalId,
        selected,
        setSelected,
      }}
    >
      {children}
    </Provider>
  )
}

export default SummaryProvider
